/* 🤖 this file was generated by svg-to-ts */
export const mgcIconRightSmallCuteRe: {
  name: 'right-small-cute-re';
  data: string;
} = {
  name: 'right-small-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.728 8.217a1 1 0 0 0-.671.652c-.072.202-.07.353.007.613.078.261.226.415.802.83a9.24 9.24 0 0 1 1.475 1.369l.266.319-.266.319a9.24 9.24 0 0 1-1.475 1.369c-.589.425-.725.568-.807.849-.194.669.269 1.28.966 1.275.299-.002.462-.084 1.058-.528a10.635 10.635 0 0 0 2.143-2.12c.402-.532.474-.709.474-1.164 0-.333-.013-.407-.11-.604-.231-.469-1.039-1.43-1.701-2.022-.441-.394-1.133-.92-1.407-1.069a1.007 1.007 0 0 0-.754-.088"/></svg>`
};
